//import dayjs from "dayjs"; // TODO: to remove - for mocking only

import http from ":http";

import Numbers from "%const/numbers";

import {
  FETCH_TAGS,
  ADD_TAG,
  UPDATE_TAG,
  DELETE_TAG,
  FETCH_VIDEOS,
  FETCH_VIDEO_SOURCES,
  UPLOAD_THUMBNAIL,
  ADD_VIDEO,
  UPDATE_VIDEO,
  DELETE_VIDEO
} from ":actions";

import {
  SET_VIDEOS,
  SET_VIDEO_SOURCES,
  SET_TAGS,
  SELECT_TAG,
  TOGGLE_TAG_SELECTION,
  CLEAR_SELECTED_TAGS,
  SWITCH_DARK_MODE,
  SET_VIDEOS_QUERY,
  CLEAR_VIDEOS_QUERY
} from ":mutations";

const state = {
  videos: {
    content: [],
    page: 1,
    size: 0,
    totalPages: 0
  },
  videoSources: {
    content: [],
    page: 1,
    query: "",
    size: 0,
    totalPages: 0
  },
  tags: [],
  videosQuery: {
    title: "",
    dateFrom: "",
    dateTo: ""
  },
  selectedTags: [],
  darkMode: false
};

const mutations = {
  [SET_VIDEOS](state, { content, page, size, totalPages }) {
    state.videos = { content, page, size, totalPages };
  },

  [SET_VIDEO_SOURCES](state, { content, page, size, query, totalPages }) {
    state.videoSources = { content, page, size, query, totalPages };
  },

  [SET_TAGS](state, { tags }) {
    state.tags = tags;
  },

  [SELECT_TAG]({ selectedTags }, { tag }) {
    if (!selectedTags.includes(tag.id)) {
      selectedTags.push(tag.id);
    }
  },

  [TOGGLE_TAG_SELECTION]({ selectedTags }, { tag }) {
    const index = selectedTags.findIndex(id => tag.id === id);
    if (index > -1) {
      selectedTags.splice(index, 1);
    } else {
      selectedTags.push(tag.id);
    }
  },

  [CLEAR_SELECTED_TAGS](state) {
    state.selectedTags = [];
  },

  [SET_VIDEOS_QUERY](state, { query }) {
    state.videosQuery = query;
  },

  [CLEAR_VIDEOS_QUERY](state) {
    state.videosQuery = {
      title: "",
      dateFrom: "",
      dateTo: ""
    };
  },

  [SWITCH_DARK_MODE](state, { darkMode }) {
    state.darkMode = darkMode;
  }
};

const actions = {
  [FETCH_TAGS]({ commit }) {
    return http
      .get("/tags", { params: {
        page: 0,
        size: Numbers.MAX_PAGE_SIZE
      }})
      .then(response => commit(SET_TAGS, { tags: response.data.content }));
  },

  [ADD_TAG]({ dispatch }, { name }) {
    return http.post("/tags", { name }).then(() => dispatch(FETCH_TAGS));
  },

  [UPDATE_TAG]({ dispatch }, { id, tag }) {
    return http.patch(`/tags/${id}`, tag).then(() => dispatch(FETCH_TAGS));
  },

  [DELETE_TAG]({ dispatch }, { id }) {
    return http.delete(`/tags/${id}`).then(() => dispatch(FETCH_TAGS));
  },

  [FETCH_VIDEOS]({ state, commit }, { page, size, query }) {
    return http
      .get("/videos", {
        params: {
          page: page - 1,
          sort: "createdDate,desc",
          query,
          tags:
            state.selectedTags.length > 0
              ? state.selectedTags.join(",")
              : undefined,
          size
        }
      })
      .then(response =>
        commit(SET_VIDEOS, {
          content: response.data.content,
          totalPages: response.data.totalPages,
          page,
          size
        })
      );
  },

  [FETCH_VIDEO_SOURCES]({ commit }, { page, size, query }) {
    return http
      .get("/video-sources", {
        params: {
          page: page - 1,
          size,
          sort: "date,desc",
          fields: "path,usedBy.title",
          query
        }
      })
      .then(response =>
        commit(SET_VIDEO_SOURCES, {
          content: response.data.content,
          totalPages: response.data.totalPages,
          size: response.data.size,
          query,
          page
        })
      );
  },

  [UPLOAD_THUMBNAIL](_, { image }) {
    const form = new FormData();
    form.append("image", image);
    return http.put("/thumbnails", form);
  },

  [ADD_VIDEO]({ state, dispatch }, { video }) {
    return http.post("/videos", video).then(() =>
      dispatch(FETCH_VIDEOS, {
        page: 1,
        size: state.videos.size
      })
    );
  },

  [UPDATE_VIDEO]({ state, dispatch }, { id, video }) {
    return http.patch(`/videos/${id}`, video).then(() =>
      dispatch(FETCH_VIDEOS, {
        page: state.videos.page,
        size: state.videos.size
      })
    );
  },

  [DELETE_VIDEO]({ state, dispatch }, { id }) {
    return http.delete(`/videos/${id}`).then(() =>
      dispatch(FETCH_VIDEOS, {
        page: state.videos.page,
        size: state.videos.size
      })
    );

    // Fixme: make sure that after removing video of last page, user is moving from already not existing page to the previous one
  }
};

const getters = {
  selectedTagsOnTop: ({ tags, selectedTags }) =>
    tags
      .map(tag => ({ ...tag, selected: selectedTags.includes(tag.id) }))
      .sort((a, b) => (a.name > b.name ? 1 : -1))
      .sort((a, b) => (a.selected === b.selected ? 0 : a.selected ? -1 : 1)),

  prepareVideosQuery: ({ videosQuery, selectedTags }) => (page, size) => ({
    ...videosQuery,
    tags: selectedTags,
    page,
    size
  })
};

export default {
  state,
  mutations,
  actions,
  getters
};
